import { game_session } from './api/entities';

export const actions = {
  resetGameSessionState: 'RESET_GAME_SESSION_STATE',
  createGameSession: 'CREATE_GAME_SESSION',
  updateGameSession: 'UPDATE_GAME_SESSION',
  listGameSession: 'LIST_GAME_SESSION',
  getGameSession: 'GET_GAME_SESSION',
};

export function resetGameSessionState() {
  return { type: actions.resetGameSessionState };
}

export function createGameSession(gameSessionObject) {
  return game_session.create(actions.createGameSession, gameSessionObject, []);
}

export function updateGameSession(gameSessionId, gameSessionObject) {
  return game_session.update(actions.updateGameSession, gameSessionId, gameSessionObject, []);
}

export function getGameSessions(query, sort) {
  return game_session.list(actions.listGameSession, query, sort);
}

export function getGameSession(gameSessionId) {
  return game_session.get(actions.getGameSession, gameSessionId, []);
}

const INITIAL_STATE = {
  game_sessions: [],
  game_session: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.resetGameSessionState:
      return {
        ...INITIAL_STATE,
      };
    case actions.createGameSession:
      return {
        ...state,
        game_sessions: action.body ? [...state.game_sessions, action.body] : state.game_sessions,
      };
    case actions.listGameSession:
      return {
        ...state,
        game_sessions: action.body ? action.body._items : state.game_sessions,
      };
    case actions.getGameSession:
      return {
        ...state,
        game_session: action.body ? action.body : state.game_session,
      };
    case actions.updateGameSession:
      return {
        ...state,
        id: action.body ? action.body : null,
      };
    default:
      return {
        ...state,
      };
  }
}
